var SoftwareItem = (function () {
    function SoftwareItem(apiItem) {
        if (apiItem === void 0) { apiItem = {}; }
        this.releaseNotesPageUrl = apiItem.releaseNotesPageUrl || '';
        this.fileDate = (apiItem.fileDate || '').split('T')[0].replace(/-/g, '/');
        this.fileVersion = apiItem.fileVersion || '';
        this.marketLocales = (apiItem.marketLocales || []).map(function (x) { return x.toLowerCase(); });
        this.languageTitle = apiItem.languageTitle || '';
        this.platform = apiItem.platform || '';
        this.documentType = apiItem.documentType || '';
        this.documentTypeTranslation = apiItem.documentTypeTranslation || this.documentType;
        this.fileUrl = apiItem.fileUrl || '';
    }
    return SoftwareItem;
}());
export { SoftwareItem };
